import ACCOUNTS_PAYABLE from './accountsPayable';
import BANKS from './banks';
import CONTINGENTS from './contingents';
import OTHER from './other';
import OTHER_INSTALLMENTS from './otherInstallments';
import UNPAID_TAXES from './unpaidTaxes';

export default {
  accounts_payable: ACCOUNTS_PAYABLE,
  banks: BANKS,
  contingents: CONTINGENTS,
  other: OTHER,
  other_installments: OTHER_INSTALLMENTS,
  unpaid_taxes: UNPAID_TAXES,
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/liabilities/schemas/index.js